import {
  beEmailMessageApiGetMessageLazyDetails,
  beEmailMessageApiSearchMessages,
} from 'Api/beEmailMessageApi'

import { STORE_KEY_ID_LIST, storeGet } from 'mailup-react-helpers'

import { INPUT_MESSAGES_MAX_ITEMS } from 'Constants'

export const fetchMessages = async (
  searchTerm: string,
): Promise<{
  items: Array<{ label: string; value: number }>
  totalItems: number
}> => {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const { Items, TotalItems } = await beEmailMessageApiSearchMessages(
    idList,
    {
      pageNumber: 1,
      pageSize: INPUT_MESSAGES_MAX_ITEMS,
      orderBy: 'Id',
      orderDescending: true,
    },
    {
      SearchText: searchTerm,
    },
  )

  return {
    items: Items.map(({ Id, Subject }) => ({
      value: Id,
      label: `${Id} - ${Subject}`,
    })),
    totalItems: TotalItems,
  }
}

export const fetchMessageById = async (
  id: number,
): Promise<{ label: string; value: number } | undefined> => {
  const res = await beEmailMessageApiGetMessageLazyDetails(id)

  if (res !== null && res !== undefined) {
    return {
      value: res.Id,
      label: `${res.Id} - ${res.Subject}`,
    }
  }

  return undefined
}
